// Styles
import '@mdi/font/css/materialdesignicons.css'
import '@/styles/main.sass'

// Vuetify
import { createVuetify, ThemeDefinition } from 'vuetify'

const defaultTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: "#F5F7F9",
    primary: "#4A5EE5",
  }
}

export default createVuetify({
  theme: {
    defaultTheme: "defaultTheme",
    themes: {
      defaultTheme
    }
  },
  defaults: {
    global: {
      
    },
    VSelect: {
      color: "primary",
      menuIcon: "mdi-chevron-down"
    },
    VTextField: {
      color: "primary"
    },
    VCheckbox: {
      color: "primary"
    },
    VAppBar: {
      elevation: 0
    },
    VAvatar: {
      color: "grey-lighten-1"
    },
  } 
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
})
